import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  GetOrderProductsRequest,
  ClaimStatusType,
  OrderStatusType,
  GetShippingsRequest,
  PutShippingsAssignInvoiceRequest,
} from 'supporter';
import { convertProductUri, ncpPopup } from '@/utils/commonUtils';

@Component
export default class OrderDetailMixin extends Vue {
  @Prop({ default: '' })
  public productUrl?: any;

  @Prop({ default: (): any => [] })
  public deliveryCompanyTypeArr: any;

  @Prop({ required: false, default: false })
  private isNaverPay: boolean;

  public productInfo: any = [];
  public canEditInvoiceStatus: any = [
    'DEPOSIT_WAIT',
    'PAY_DONE',
    'PRODUCT_PREPARE',
    'DELIVERY_PREPARE',
    'DELIVERY_ING',
    'DELIVERY_DONE',
  ];
  public showClaimDetailBtnTypeArr: any = [
    'CANCEL_DONE',
    'EXCHANGE_DONE',
    'RETURN_REQUEST',
    'EXCHANGE_PROC_REQUEST_PAY',
  ];
  public shippingNosArr: any = [];
  public shippingResp: any = [];
  public showChangeDeliveryStatusBtnArr: any = [
    'PAY_DONE',
    'PRODUCT_PREPARE',
    'DELIVERY_PREPARE',
    'DELIVERY_ING',
    'DELIVERY_DONE',
  ];
  public theCancelAll: boolean = false;
  public orderCancelAll: boolean = false;
  public taskMessageInfo: any;

  public showProductPop(data: any): any {
    let arr: any = JSON.parse(data.setOptionJson);
    if (!arr || arr.length === 0) {
      return;
    }
    let mallProductNoArr: any = [];
    arr.map((item: any): any => {
      this.$set(item, 'theMallProductNo', data.mallProductNo);

      if (mallProductNoArr.indexOf(item.mallProductNo) < 0) {
        mallProductNoArr.push(item.mallProductNo);
      }
    });
    this.formatterPopData(arr, 'mallProductNo', 'rowSpan');

    mallProductNoArr.map((item: any): any => {
      let theNoArr: any = arr.filter((arrItem: any): any => {
        return item === arrItem.mallProductNo;
      });
      // 添加各个表格的rowspan
      this.formatterPopData(theNoArr, 'productManagementCd', 'manageSpan');
      this.formatterPopData(theNoArr, 'productName', 'pnSpan');
      this.formatterPopData(theNoArr, 'mallOptionNo', 'moSpan');
      this.formatterPopData(theNoArr, 'optionManagementCd', 'omSpan');
    });
    this.$emit('showProductPop', arr);
  }
  public formatterPopData(theArr: any, bigFlag: string, spanName: string): any {
    let bigGroup: any = [];
    theArr.map((item: any): any => {
      if (bigGroup.indexOf(item[bigFlag]) < 0) {
        bigGroup.push(item[bigFlag]);
      }
    });
    bigGroup.map((item: any): any => {
      let rowNum: any = null;
      rowNum = theArr.filter((arrItem: any): any => {
        return arrItem[bigFlag] === item;
      }).length;

      let firstItem: any = [];
      theArr.forEach((arrItem: any): any => {
        if (arrItem[bigFlag] === item && firstItem.indexOf(item) < 0) {
          this.$set(arrItem, spanName, rowNum);
          firstItem.push(item);
        }
      });
    });
  }
  public checkEditInvoice(status: any): any {
    if (this.canEditInvoiceStatus.indexOf(status) > -1) {
      return true;
    } else {
      return false;
    }
  }
  public getDeliveryCompaniesLabel(type: any): any {
    let conpanyType: any = '';
    this.deliveryCompanyTypeArr.forEach((item: any): any => {
      if (item.deliveryCompanyType === type) {
        conpanyType = item.label;
      }
    });
    return conpanyType;
  }
  public handleWinOpen(mallProductNo: any): void {
    const uri = convertProductUri(this.productUrl, mallProductNo);
    window.open(uri);
  }
  public getOrderProductInfo(): void {
    let ProductInfoRequest: GetOrderProductsRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any,
      },
    };
    this.$api.getOrderProducts(ProductInfoRequest).then((res): any => {
      this.productInfo = [];
      let content: any = [...res.data];
      this.productInfo = [...this.formatterProductInfo(content, 'orderOptions')];
      this.checkCancancelAll(this.productInfo); // check 是否是allcancel
      this.productInfo = [...this.mergeRow(this.productInfo)].map(({ freeGiftConditionBrokenType, ...rest }) => ({
        isBroken: freeGiftConditionBrokenType === 'CLAIM_DONE',
        freeGiftConditionBrokenType,
        ...rest,
      }));

      this.productInfo.map((item: any, val): any => {
        if (item.setOptionJson !== null) {
          this.productInfo[val].setOptions = JSON.parse(item.setOptionJson);
        }
        this.taskMessageInfo.map((tItem: any): any => {
          this.productInfo[val].taskMessageStatus =
            item.orderOptionNo === tItem.orderOptionNo && tItem.taskMessageStatus === 'PROCESSING';
        });
      });
      this.$emit('emitProductInfo', this.productInfo);
      this.$emit('emitOrderProductInfo', res.data);
      this.formatterMallNoShippingGet(); //如果mallNo 唯一
    });
  }

  private showOption(optionName: string, optionValue: string) {
    let opName: string[] = optionName.split('|');
    let opValue: string[] = optionValue.split('|');
    let returnValue = '';
    for (let i = 0; i < opName.length; i++) {
      returnValue = returnValue + opName[i] + ':' + opValue[i] + ' | ';
    }

    return returnValue.substring(0, returnValue.length - 3);
  }

  public checkCancancelAll(arr: any): void {
    if (arr.length === 0) {
      return;
    }
    let status: any = ['DEPOSIT_WAIT']; //全部取消
    this.theCancelAll = arr.every((item: any): any => {
      return status.indexOf(item.orderStatusType) > -1 && !item.claimStatusType;
    });
    this.orderCancelAll = arr.every((item: any): any => {
      return item.canCancel;
    });
  }
  public onClickSaveInvoiceBtn(ev: any): void {
    if (ev.deliveryCompanyType === undefined) {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_1'));
      return;
    }
    if (!ev.invoiceTex.trim()) {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_2'));
      return;
    }

    // let theInvoice: Invoice[] = [{shippingNo: ev.shippingNo, deliveryCompanyType: ev.deliveryCompanyType, invoiceNo: ev.invoiceTex}];

    let invoicesRequest: PutShippingsAssignInvoiceRequest = {
      data: {
        shippingNo: ev.shippingNo,
        deliveryCompanyType: ev.deliveryCompanyType,
        invoiceNo: ev.invoiceTex,
        mallNo: ev.mallNo,
      },
    };
    this.$api.putShippingsAssignInvoice(invoicesRequest).then((): any => {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_3'));
      location.reload();
    });
    // this.$api.putShippingsAssignInvoices(invoicesRequest).then((): any => {
    //   alert(this.$t('ORDER_ORDER_DETAIL_ALERT_3'));
    //   location.reload();
    // });
  }
  public formatterMallNoShippingGet(): void {
    this.shippingNosArr = [];
    let mallNoArr: any[] = [];
    let mallAndShipping: any[] = [];
    let formaterMAS: any[] = [];
    if (this.productInfo.length === 0) {
      return;
    }
    this.productInfo.forEach((item: any): any => {
      this.$set(item, 'addInvoice', true);
      mallAndShipping.push({ mallNo: item.mallNo, shippingNo: item.shippingNo });
      if (this.shippingNosArr.indexOf(item.shippingNo) < 0) {
        this.shippingNosArr.push(item.shippingNo);
      }
    });
    mallAndShipping.forEach((mas: any): any => {
      if (mallNoArr.indexOf(mas.mallNo) < 0) {
        mallNoArr.push(mas.mallNo);
        formaterMAS.push(mas);
      } else {
        formaterMAS.forEach((fmas: any): any => {
          if (fmas.mallNo === mas.mallNo) {
            fmas.shippingNo = fmas.shippingNo.toString() + ',' + mas.shippingNo;
          }
        });
      }
    });
    formaterMAS.forEach((fmas: any): any => {
      this.getTheShippings(fmas.mallNo, fmas.shippingNo);
    });
  }
  public getTheShippings(mallNo: string, shippingNos: string): any {
    let shippingRequest: GetShippingsRequest = {
      params: {
        mallNo: mallNo,
        shippingNos: shippingNos,
      },
    };
    this.$api.getShippings(shippingRequest).then((res): any => {
      this.shippingResp = [];
      this.shippingResp = res.data;
      this.checkReceiverBtnShow();
      this.$emit('emitShippingResp', this.shippingResp);
      this.useShippingRespFormatterProductInfo();
      this.setDeliveryAmt(this.shippingResp, this.productInfo);
    });
  }
  public useShippingRespFormatterProductInfo(): void {
    let nullInvoice: any = [];
    this.shippingResp.forEach((item: any): any => {
      // set prepaid
      if (this.productInfo.length === 0) {
        return;
      }
      this.productInfo.map((pro: any): any => {
        if (pro.shippingNo === item.shippingNo && pro.mallNo === item.mallNo) {
          this.$set(pro, 'prepaid', item.prepaid);

          // set showChangeDelivery
          if (this.canEditInvoiceStatus.indexOf(pro.orderStatusType) < 0 && item.invoiceNo) {
            this.$set(pro, 'showChangeDelivery', true);
          }

          if (!item.invoiceNo || !item.deliveryCompanyType || (!item.deliveryType as any) === 'DIRECT_DELIVERY') {
            pro.addInvoice = true;

            // 获取invoice为null 并且orderStatusType处于无法修改的状态的shippingNo
            if (!this.checkEditInvoice(pro.orderStatusType)) {
              if (nullInvoice.indexOf(pro.shippingNo) < 0) {
                nullInvoice.push(pro.shippingNo);
              }
            }
          } else {
            pro.addInvoice = false;
          }
        }
      });
    });
    // 当既有 可输入的invoice 又有为‘-’的shippingNo的时后，创建了一个‘hanAddInvoice’来判断
    if (nullInvoice.length === 0) {
      return;
    }
    nullInvoice.map((nullShippingNo: any): any => {
      this.productInfo.forEach((pro: any): any => {
        if (pro.shippingNo === nullShippingNo && this.checkEditInvoice(pro.orderStatusType)) {
          this.productInfo.map((theP: any): any => {
            if (theP.shippingNo === nullShippingNo) {
              this.$set(theP, 'hanAddInvoice', true);
            }
          });
        }
      });
    });
  }
  public setDeliveryAmt(shippingArr: any, productInfoArr: any): void {
    shippingArr.forEach((sItem: any): any => {
      productInfoArr.map((pItem: any): any => {
        if (sItem.shippingNo === pItem.shippingNo && sItem.mallNo === pItem.mallNo) {
          this.$set(pItem, 'baseDeliveryAmt', sItem.deliveryAmt);
          this.$set(pItem, 'adjustedDeliveryAmt', sItem.adjustedDeliveryAmt);
          this.$set(pItem, 'remoteDeliveryAmt', sItem.remoteDeliveryAmt);
          this.$set(pItem, 'adjustedRemoteDeliveryAmt', sItem.adjustedRemoteDeliveryAmt);
          this.$set(pItem, 'deliveryType', sItem.deliveryType);
          this.$set(pItem, 'combined', sItem.combined);
          this.$set(pItem, 'devided', sItem.devided);
        }
        if (pItem.holdDelivery === true && pItem.shippingNo === sItem.shippingNo) {
          this.$set(sItem, 'holdDelivery', true);
        }
        if (pItem.reservation.holdByReservation === true && pItem.shippingNo === sItem.shippingNo) {
          this.$set(sItem, 'holdByReservation', true);
        }
      });
    });
  }
  public releaseHoldDelivery(orderOptionNo, taskMessageStatus) {
    let message;
    if (!taskMessageStatus) {
      message = this.$t('ORDER_ORDER_CONTENT_TOP_CHECKLIST_TRUE') as any;
    } else {
      message = this.$t('ORDER_ORDER_CONTENT_TOP_CHECKLIST_FALSE') as any;
    }
    if (!confirm(message)) {
      return;
    }
    let obj = {
      params: {
        orderOptionNos: orderOptionNo,
      },
    };
    this.$api.putOrderOptionsReleaseHoldDelivery(obj).then(() => {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_PUT_SUCCESS'));
      location.reload();
    });
  }
  public checkReceiverBtnShow(): void {
    const result = this.productInfo.filter((item: any) => {
      return !item.claimFinished;
    });
    this.shippingResp.map((item: any): any => {
      if (result.map((rItem: any) => rItem.shippingNo).indexOf(item.shippingNo) > -1) {
        this.$set(item, 'receiverChangeBtn', true);
      }
    });
  }
  public onClickChangeInvoiceBtn(data: any, opn: any, mallNo: any, shippingNo: any): void {
    data.forEach((item: any): any => {
      if (item.orderProductNo === opn) {
        this.$set(item, 'addInvoice', true);
        item.deliveryCompanyType = this.fillterShippingIfo(this.shippingResp, mallNo, shippingNo).deliveryCompanyType;
        item.invoiceTex = this.fillterShippingIfo(this.shippingResp, mallNo, shippingNo).invoiceNo;
      }
    });
  }
  public fillterShippingIfo(data: any, mallNo: any, shippingNo: any): any {
    let info: any = {};

    info = data.filter((item: any): any => {
      return item.mallNo === mallNo && item.shippingNo === shippingNo;
    });

    return info[0];
  }
  public popupReturn(orderProductOptionNo: any, escrow: boolean, orderStatusType: string, item: any): void {
    if (orderStatusType === 'BUY_CONFIRM' && item.payType === 'NAVER_PAY') {
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_NAVER_PAY_HOLD_ALERT'));
      return;
    }
    // 新增
    if (this.checkReturn(item)) {
      return;
    }

    if (escrow && orderStatusType !== 'DELIVERY_DONE' && orderStatusType !== 'BUY_CONFIRM') {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_6'));
    } else {
      let title: any = this.$t('ORDER_ORDER_DETAIL_TITLE_1');
      ncpPopup(`/claim/returnPopup?orderProductOptionNo=${orderProductOptionNo}`, title, 1024, 500);
    }
  }
  public popupExchange(
    orderProductOptionNo: any,
    escrow: any,
    orderStatusType: any,
    shippingResp: [],
    payType: string,
    item: any,
  ): any {
    if (this.isNaverPay) {
      alert(this.$t('ORDER_ORDER_DETAIL_NAVER_PAY_CENTER_ALERT'));
      return;
    }

    let holdDeliveryState = false;
    let holdByReservation = false;
    if (shippingResp) {
      shippingResp.map((hData: any): any => {
        if (hData.holdDelivery && hData.shippingNo === item.shippingNo) {
          holdDeliveryState = hData.holdDelivery;
        }
        if (hData.holdByReservation && hData.shippingNo === item.shippingNo) {
          holdByReservation = hData.holdByReservation;
        }
      });
    }
    if (payType === 'ESCROW_REALTIME_ACCOUNT_TRANSFER' || payType === 'ESCROW_VIRTUAL_ACCOUNT ') {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_13'));
      return;
    }
    if (
      holdDeliveryState &&
      (orderStatusType === 'PRODUCT_PREPARE' || orderStatusType === 'DELIVERY_PREPARE') &&
      !confirm(this.$t('ORDER_ORDER_DETAIL_CONFIRM_1') as any)
    ) {
      return;
    }
    if (holdByReservation && !confirm(this.$t('ORDER_ORDER_DETAIL_CONFIRM_2') as any)) {
      return;
    }
    if (escrow && orderStatusType !== 'DELIVERY_DONE' && orderStatusType !== 'BUY_CONFIRM') {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_6'));
    } else {
      let title: any = this.$t('ORDER_ORDER_DETAIL_TITLE_2');
      ncpPopup(`/claim/exchangePopup?orderProductOptionNo=${orderProductOptionNo}`, title, 1024, 500);
    }
  }
  public popupCancelAll(orderNo: string, orderStatusType: string, shippingResp: [], item: any): void {
    if (orderStatusType === 'DEPOSIT_WAIT' && this.isNaverPay) {
      alert(this.$t('ORDER_ORDER_DETAIL_NAVER_PAY_CENTER_ALERT'));
      return;
    }

    let holdDeliveryState = false;
    let holdByReservation = false;
    if (shippingResp) {
      shippingResp.map((hData: any): any => {
        if (hData.holdDelivery && hData.shippingNo === item.shippingNo) {
          holdDeliveryState = hData.holdDelivery;
        }
        if (hData.holdByReservation && hData.shippingNo === item.shippingNo) {
          holdByReservation = hData.holdByReservation;
        }
      });
    }
    if (holdByReservation && !confirm(this.$t('ORDER_ORDER_DETAIL_CONFIRM_2') as any)) {
      return;
    }
    if (
      holdDeliveryState &&
      (orderStatusType === 'PRODUCT_PREPARE' || orderStatusType === 'DELIVERY_PREPARE') &&
      !confirm(this.$t('ORDER_ORDER_DETAIL_CONFIRM_1') as any)
    ) {
      return;
    }
    let isBefore = orderStatusType !== 'PAY_DONE';
    let titleBefore: any = this.$t('ORDER_ORDER_DETAIL_TITLE_5');
    let titleNotBefore: any = this.$t('ORDER_ORDER_DETAIL_TITLE_6');
    ncpPopup(
      '/claim/cancelAllPopup?orderNo=' + orderNo + (isBefore ? '&type=before' : '&type=normal'),
      isBefore ? titleBefore : titleNotBefore,
      1024,
      500,
    );
  }
  public openPopupCancel(
    orderOptionNo: any,
    escrow: boolean,
    orderStatusType: string,
    shippingResp: [],
    item: any,
  ): void {
    //TODO: 네이버 페이 주문형의 클레임 신청은 환불방법 default가 네이버 페이 주문형으로 set 되도록 수정

    let holdDeliveryState = false;
    let holdByReservation = false;
    if (shippingResp) {
      shippingResp.map((hData: any): any => {
        if (hData.holdDelivery && hData.shippingNo === item.shippingNo) {
          holdDeliveryState = hData.holdDelivery;
        }
        if (hData.holdByReservation && hData.shippingNo === item.shippingNo) {
          holdByReservation = hData.holdByReservation;
        }
      });
    }
    if (holdByReservation && !confirm(this.$t('ORDER_ORDER_DETAIL_CONFIRM_2') as any)) {
      return;
    }
    if (
      holdDeliveryState &&
      (orderStatusType === 'PRODUCT_PREPARE' || orderStatusType === 'DELIVERY_PREPARE') &&
      !confirm(this.$t('ORDER_ORDER_DETAIL_CONFIRM_1') as any)
    ) {
      return;
    }
    if (item.payType === 'ESCROW_REALTIME_ACCOUNT_TRANSFER' || item.payType === 'ESCROW_VIRTUAL_ACCOUNT') {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_15'));
      return;
    }
    if (escrow && orderStatusType != 'DELIVERY_DONE' && orderStatusType != 'BUY_CONFIRM') {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_7'));
    } else {
      let title: any = this.$t('ORDER_ORDER_DETAIL_TITLE_4');
      ncpPopup('/claim/cancelPopup?orderProductOptionNo=' + orderOptionNo, title, 1024, 500);
    }
  }
  public checkReturn(data: any): any {
    if (data.payType === 'ESCROW_REALTIME_ACCOUNT_TRANSFER' || data.payType === 'ESCROW_VIRTUAL_ACCOUNT') {
      let alertFlag: any = false;
      let confirmFlag: any = false;
      this.productInfo.map((item: any): any => {
        if (item.mallProductNo === data.mallProductNo && item.orderStatusType !== 'BUY_CONFIRM') {
          alertFlag = true;
          confirmFlag = true;
        }
      });
      if (alertFlag) {
        alert(this.$t('ORDER_ORDER_DETAIL_ALERT_14'));
        return true;
      }
      if (!confirmFlag) {
        return !confirm(this.$t('ORDER_ORDER_DETAIL_CONFIRM_3') as any);
      }
    }
  }
  public totalPrice(ev: any): any {
    if (ev.immediateDiscountedPrice > ev.adjustedAmt) {
      return ev.adjustedAmt;
    } else {
      return ev.adjustedAmt;
    }
  }
  public openDetailPopup(orderOptionNo: any, claimNo: any): void {
    let title: any = this.$t('ORDER_ORDER_DETAIL_TITLE_3');
    ncpPopup(
      `/claim/viewPopup?orderProductOptionNo=${orderOptionNo}&isResult=true&claimNo=${claimNo}`,
      title,
      1024,
      500,
    );
  }

  public orderStatusTypeLabel(type: OrderStatusType, holdDelivery: boolean): any {
    let label: any = '';
    switch (type) {
      case 'DEPOSIT_WAIT':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_DEPOSIT_WAIT');
        break;
      case 'PAY_DONE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_PAY_DONE');
        break;
      case 'PRODUCT_PREPARE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_PRODUCT_PREPARE');
        break;
      case 'DELIVERY_PREPARE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_DELIVERY_PREPARE');
        break;
      case 'DELIVERY_ING':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_DELIVERY_ING');
        break;
      case 'DELIVERY_DONE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_DELIVERY_DONE');
        break;
      case 'BUY_CONFIRM':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_BUY_CONFIRM');
        break;
      case 'CANCEL_DONE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_CANCEL_DONE');
        break;
      case 'RETURN_DONE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_RETURN_DONE');
        break;
      case 'EXCHANGE_DONE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_EXCHANGE_DONE');
        break;
      case 'PAY_WAIT':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_PAY_WAIT');
        break;
      case 'PAY_CANCEL':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_PAY_CANCEL');
        break;
      case 'PAY_FAIL':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_PAY_FAIL');
        break;
      case 'DELETE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_DELETE');
        break;
      case 'EXCHANGE_WAIT':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_EXCHANGE_WAIT');
        break;
      case 'REFUND_DONE':
        label = this.$t('ORDER_ORDER_DETAIL_STATUS_REFUND_DONE');
        break;
      default:
        label = '';
    }

    if (holdDelivery) {
      label += this.$t('ORDER_ORDER_DETAIL_STATUS_HOLD_DELIVERY')
    }

    return label;
  }
  public claimStatusTypeLabel(type: ClaimStatusType): any {
    let label: any = '';
    if (type === 'CANCEL_NO_REFUND') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_CANCEL_NO_REFUND');
    }
    if (type === 'CANCEL_REQUEST') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_CANCEL_REQUEST');
    }
    if (type === 'CANCEL_PROC_REQUEST_REFUND') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_CANCEL_PROC_REQUEST_REFUND');
    }
    if (type === 'CANCEL_PROC_WAITING_REFUND') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_CANCEL_PROC_WAITING_REFUND');
    }
    if (type === 'CANCEL_DONE') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_CANCEL_DONE');
    }
    if (type === 'RETURN_REQUEST') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_RETURN_REQUEST');
    }
    if (type === 'RETURN_REJECT_REQUEST') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_RETURN_REJECT_REQUEST');
    }
    if (type === 'RETURN_PROC_BEFORE_RECEIVE') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_RETURN_PROC_BEFORE_RECEIVE');
    }
    if (type === 'RETURN_PROC_REQUEST_REFUND') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_RETURN_PROC_REQUEST_REFUND');
    }
    if (type === 'RETURN_PROC_WAITING_REFUND') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_RETURN_PROC_WAITING_REFUND');
    }
    if (type === 'RETURN_REFUND_AMT_ADJUST_REQUESTED') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_RETURN_REFUND_AMT_ADJUST_REQUESTED');
    }
    if (type === 'RETURN_DONE') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_RETURN_DONE');
    }
    if (type === 'RETURN_NO_REFUND') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_RETURN_NO_REFUND');
    }
    if (type === 'EXCHANGE_REQUEST') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_REQUEST');
    }
    if (type === 'EXCHANGE_REJECT_REQUEST') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_REJECT_REQUEST');
    }
    if (type === 'EXCHANGE_PROC_BEFORE_RECEIVE') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_PROC_BEFORE_RECEIVE');
    }
    if (type === 'EXCHANGE_PROC_REQUEST_PAY') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_PROC_REQUEST_PAY');
    }
    if (type === 'EXCHANGE_PROC_WAITING') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_PROC_WAITING');
    }
    if (type === 'EXCHANGE_PROC_WAITING_PAY') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_PROC_WAITING_PAY');
    }
    if (type === 'EXCHANGE_DONE_PAY_DONE') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_DONE_PAY_DONE');
    }
    if (type === 'EXCHANGE_PROC_REQUEST_REFUND') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_PROC_REQUEST_REFUND');
    }
    if (type === 'EXCHANGE_PROC_WAITING_REFUND') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_PROC_WAITING_REFUND');
    }
    if (type === 'EXCHANGE_DONE_REFUND_DONE') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_DONE_REFUND_DONE');
    }
    if (type === 'EXCHANGE_DONE') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_EXCHANGE_DONE');
    }
    if (type === 'NONE') {
      label = this.$t('ORDER_ORDER_DETAIL_CLAIM_STATUS_NONE');
    }
    return label;
  }
  public onClickInvoiceInfo(no: any, type: any): void {
    const deliveryCompanyCd = type;
    const invoiceNo = no;
    switch (deliveryCompanyCd) {
      case 'CJ':
        window.open(
          `https://www.doortodoor.co.kr/parcel/doortodoor.do?fsp_action=PARC_ACT_002&fsp_cmd=retrieveInvNoACT&invc_no=${invoiceNo}`,
        );
        break; // CJ GLS택배
      case 'POST':
        window.open(`http://service.epost.go.kr/trace.RetrieveRegiPrclDeliv.postal?sid1=${invoiceNo}`);
        break; // 우체국택배
      case 'HANJIN':
        window.open(`http://www.hanjinexpress.hanjin.net/customer/hddcw99gm.tracking?w_num=${invoiceNo}`);
        break; // 한진택배
      case 'GTX':
        window.open(`http://www.gtxlogis.co.kr/tracking/default.asp?awblno=${invoiceNo}`);
        break; // GTX로지스
      case 'LOTTE':
        window.open(`https://ftr.alps.llogis.com:18260/ftr/tracking.html?${invoiceNo}`);
        break; // 현대택배
      case 'KGB':
        window.open(`http://www.kgbls.co.kr//sub5/trace.asp?f_slipno=${invoiceNo}`);
        break; // KGB택배
      case 'LOGEN':
        window.open(`http://d2d.ilogen.com/d2d/delivery/invoice_tracesearch_quick.jsp?slipno=${invoiceNo}`);
        break; // 로젠택배
      case 'GSI':
        window.open(`http://www.gsiexpress.com/track_pop.php?textfield=${invoiceNo}&track_type=ship_num`);
        break; // GSI Express
      case 'KGL':
        window.open(`http://www.kglogis.co.kr/contents/waybill.jsp?item_no=${invoiceNo}`);
        break; // KG로지스
      case 'INTRAS':
        window.open(`http://intras.co.jp/delivery/tracking?number=${invoiceNo}`);
        break; // INTRAS
      case 'CHUNIL':
        window.open(`http://www.chunil.co.kr/HTrace/HTrace.jsp?transNo=${invoiceNo}`);
        break;
      case 'KDEXP':
        window.open(`http://kdexp.com/basicNewDelivery.kd?barcode=${invoiceNo}`);
        break;
      case 'HDEXP':
        window.open(`http://www.hdexp.co.kr/basic_delivery.hd?barcode=${invoiceNo}`);
        break;
      case 'ILYANG':
        window.open(`https://www.ilyanglogis.com/functionality/popup_result.asp?hawb_no=${invoiceNo}`);
        break;
      default:
        alert(this.$t('ORDER_ORDER_DETAIL_ALERT_4'));
    }
  }
  public formatterProductInfo(arr: any, attribute: string): any {
    let newArr: any[] = [];
    arr.forEach((item: any): any => {
      item[attribute].forEach((opItem: any): any => {
        let obj: any = {};
        Object.keys(item).forEach((name: any): any => {
          if (name !== attribute) {
            obj[name] = item[name];
          }
        });
        Object.keys(opItem).forEach((opName: any): any => {
          obj[opName] = opItem[opName];
        });
        newArr.push(obj);
      });
    });
    newArr.sort((a: any, b: any): any => {
      return a.partnerNo - b.partnerNo;
    });
    return newArr;
  }
  public mergeRow(arr: any): any {
    let bigGroup: any = [];
    let midGroup: any = [];
    let smallGroup: any = [];
    let newArr: any = [];

    if (arr.length === 0) {
      return;
    }
    arr.forEach((item: any): any => {
      if (bigGroup.indexOf(item.partnerNo) < 0) {
        bigGroup.push(item.partnerNo);
        let num: any = arr.filter((item1: any): any => {
          return item1.partnerNo === item.partnerNo;
        }).length;
        item.bRowSpan = num;
      }
      if (midGroup.indexOf(item.shippingNo) < 0) {
        midGroup.push(item.shippingNo);
      }
      if (smallGroup.indexOf(item.claimNo) < 0) {
        smallGroup.push(item.claimNo);
      }
    });
    midGroup.forEach((sItem: any): any => {
      arr.forEach((item: any): any => {
        if (item.shippingNo === sItem) {
          newArr.push(item);
        }
      });
    });
    smallGroup.forEach((sItem: any): any => {
      let group: any[] = [];
      newArr.forEach((item: any): any => {
        if (group.indexOf(item.claimNo) < 0 && sItem === item.claimNo) {
          group.push(item.claimNo);
          let claimNums: any = newArr.filter((item1: any): any => {
            return (
              item1.shippingNo === item.shippingNo && sItem === item1.claimNo && item1.partnerNo === item.partnerNo
            );
          }).length;
          item.cRowSpan = claimNums;
        }
      });
    });
    bigGroup.forEach((pnItem: any): any => {
      let group: any[] = [];
      newArr.forEach((item: any): any => {
        if (group.indexOf(item.shippingNo) < 0 && pnItem === item.partnerNo) {
          group.push(item.shippingNo);
          let shippingNoArr: any = newArr.filter((item1: any): any => {
            return item1.shippingNo === item.shippingNo && pnItem === item1.partnerNo;
          });
          item.sRowSpan = shippingNoArr.length;
        }
      });
    });
    return newArr;
  }
}
